import type { BuyOrder } from "../types";

/** Id numérico de documento persistido en supply_document. */
export function isPersistedSupplyDocumentOrder(order: BuyOrder): boolean {
  const id = String(order.id ?? "").trim();
  return /^\d+$/.test(id);
}

/** Órdenes locales aún no guardadas en el servidor (ej. MLS-1234). */
export function isNewLocalBuyOrder(order: BuyOrder): boolean {
  return !isPersistedSupplyDocumentOrder(order);
}

export function ordersPendingSupplyDocumentCreate(orders: BuyOrder[]): BuyOrder[] {
  return orders.filter(isNewLocalBuyOrder);
}

export const REAL_PURCHASE_ORDER_MESSAGE =
  "La orden de compra ya existe en el sistema y no se puede eliminar.";

export function canDeleteSimulatedBuyOrder(order: BuyOrder): boolean {
  if (!isPersistedSupplyDocumentOrder(order)) {
    return true;
  }
  const status = String(order.document_status ?? "").trim().toLowerCase();
  return status === "" || status === "draft";
}

export function buyOrderDeleteBlockedMessage(order: BuyOrder): string | null {
  if (!isPersistedSupplyDocumentOrder(order)) {
    return null;
  }
  const status = String(order.document_status ?? "").trim().toLowerCase();
  if (status === "real") {
    return REAL_PURCHASE_ORDER_MESSAGE;
  }
  if (status !== "" && status !== "draft") {
    return "Solo se pueden eliminar órdenes simuladas en estado draft.";
  }
  return null;
}
